import React from "react";
import PropTypes from 'prop-types';
import * as S from './Coverages.Style'

import { ReactComponent as IconDFI } from '../../../assets/images/habitacional/coverage-dfi-icon.svg'
import { ReactComponent as IconMPI } from '../../../assets/images/habitacional/coverage-mip-icon.svg'
import { ReactComponent as IconDFC } from '../../../assets/images/habitacional/coverage-dfc-icon.svg'

const Coverages = ({ isTradicional = false }) => {

    const coveragesList = [
        {
            icon: <IconMPI />,
            title: 'Morte ou Invalidez Permanente - MIP',
            description: "Garante que a família permaneça no imóvel, em razão de morte ou invalidez do titular do seguro ou de coobrigados "
                + "(terceiros que assumem o financiamento na ausência do titular), a depender do contrato."
        },
        {
            icon: <IconDFI />,
            title: 'Danos Físicos ao Imóvel - DFI',
            description: "Repara os prejuízos causados ao imóvel, decorrentes de fatores externos de causa natural e "
                + "previstos no contrato do seguro, a exemplo de explosão, incêndio e alagamento. "
        },
    ]

    if (!isTradicional)
        coveragesList.push(
            {
                icon: <IconDFC />,
                title: 'Danos Físicos ao Conteúdo - DFC',
                description: "Permite a indenização de prejuízos ao conteúdo presente dentro do imóvel segurado, decorrentes de incêndio, explosão, entre outras situações "
                    + "que sejam cobertas pelo seguro. Podemos citar como conteúdo os móveis, eletrodomésticos e objetos de uso pessoal."
            }
        )

    return (
        <>
            <S.Title>Coberturas</S.Title>
            <S.Container>
                {coveragesList.map(e => {
                    return (
                        <S.Card>
                            <S.CardHeader>
                                {e.icon}
                                <S.CardParagraph isTradicional={isTradicional}>{e.title}</S.CardParagraph>
                            </S.CardHeader>
                            {e.description}
                        </S.Card>
                    )
                })}
            </S.Container>
        </>
    )
}

Coverages.prototype = {
    isTradicional: PropTypes.bool
}

export default Coverages